import { useEffect, useRef, useState } from "react";
import { motion, useInView, useMotionValue, useTransform, animate } from "framer-motion";

export function StatNumber({ value, suffix = "", label, decimals = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (v) => (decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString()));
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(mv, value, { duration: 2.4, ease: [0.19, 1, 0.22, 1] });
    const unsub = rounded.on("change", (v) => setDisplay(v));
    return () => { controls.stop(); unsub(); };
  }, [inView, value, mv, rounded]);

  return (
    <div ref={ref} className="flex flex-col gap-2">
      <div className="font-serif-display text-5xl md:text-6xl text-[color:var(--wk-bone)] tabular-nums">
        {display}
        <span className="text-[color:var(--wk-gold)]">{suffix}</span>
      </div>
      <div className="overline text-[10px]">{label}</div>
    </div>
  );
}
